module.exports = __webpack_public_path__ + "static/media/wellbeing_tools.d88afc05.png";